import * as Action from "@actions/index";

const InitialState = {
  display: true,
};

export default function Header(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Ui.Header.SHOW:
    case Action.Ui.Header.HIDE:
      return { ...state, ...action.data };
    default:
      return state;
  }
}
